import { useEffect, type FC, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useUrlWithSearchParams } from "../../helpers/routeHelpers";
import { useEnableFacilitiesManagement } from "../../helpers/context-hooks/useEnableFacilitiesManagement";

export const FacilitiesManagementRoute: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { enableFacilitiesManagement } = useEnableFacilitiesManagement();

  const redirectUrl = useUrlWithSearchParams("/");
  const navigate = useNavigate();

  useEffect(() => {
    // Perform the redirect safely after rendering completes
    if (!enableFacilitiesManagement) {
      // Facilities management not enabled, go to landing page.
      navigate(redirectUrl, { replace: true });
    }
  }, [enableFacilitiesManagement, navigate, redirectUrl]);

  return enableFacilitiesManagement ? <>{children}</> : null;
};
